import { HeadTags } from '@chegg-wt/core/types/core'

export const head: HeadTags = {
  // title should eventually be changed and made page specific instead of app specific
  title: 'EasyBib®: Free Bibliography Generator - MLA, APA, Chicago citation styles',
  metaTags: [],
}
